"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountReusability = void 0;
var DiscountReusability;
(function (DiscountReusability) {
    DiscountReusability["SingleUser"] = "singleUser";
    DiscountReusability["MultipleUsers"] = "multipleUsers";
})(DiscountReusability || (exports.DiscountReusability = DiscountReusability = {}));
//# sourceMappingURL=discount-reusability.enum.js.map